import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { useSessionInfo } from '@store';
import { BaseSessionInfoLanguage } from '@types';

export class I18nFormatHelper {
	static formatBasedOnLanguage = (value: string, language: BaseSessionInfoLanguage): string => {
		let treatedValue;
		if (language.toUpperCase() === BaseSessionInfoLanguage.EN) {
			const test = [...value];
			const test1 = test.findIndex((copy) => copy === ',');
			const test2 = test.findIndex((copy) => copy === '.');
			if (test1 !== -1) {
				test.splice(test1, 1);
			} // const finalDone = test.splice(test2, 1, ',');
			treatedValue = test.join('');
		} else {
			const test = [...value];
			const test1 = test.findIndex((copy) => copy === ',');
			const test2 = test.findIndex((copy) => copy === '.');
			if (test1 !== -1) {
				test.splice(test1, 1, '.');
			}
			if (test2 !== -1) {
				test.splice(test2, 1);
			}
			treatedValue = test.join('');
		}
		return treatedValue;
	};

	static formatAmountToEnglish = (value: number) => new Intl.NumberFormat().format(value);
}
